import DashboardLayout from "@/packages/dashboard/views/DashboardLayout.vue";
import B2B from "@/packages/c2bModules/SasaPayB2C/components/B2B.vue";
import B2C from "@/packages/c2bModules/SasaPayB2C/components/B2C.vue";
import BusinessToBeneficiary from "@/packages/c2bModules/SasaPayB2C/components/BusinessToBeneficiary.vue";
const SasaPayB2BRoutes =[
    {
        path: '/dashboard',
        component: DashboardLayout,
        children: [
            {
                path: 'sasapay-products/b2c-c2b',
                component: B2C,
                name: "B2C",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'sasapay-products/business-to-business',
                component: B2B,
                name: "b2b",
                // meta: { middleware: [Auth]},
            },
            {
                path: 'sasapay-products/business-to-beneficiary',
                component: BusinessToBeneficiary,
                name: "B2Beneficiary",
                // meta: { middleware: [Auth]},
            },
        ]
    }
];
export default SasaPayB2BRoutes;
